import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const STATUSES = [
  { value: '', label: 'Tutti' },
  { value: 'submitted', label: 'In attesa' },
  { value: 'under_review', label: 'In revisione' },
  { value: 'certified', label: 'Certificati' },
  { value: 'rejected', label: 'Rifiutati' },
  { value: 'draft', label: 'Bozze' },
];

const STATUS_META = {
  draft:        { label: 'Bozza',          cls: 'badge-gray' },
  submitted:    { label: 'In attesa',      cls: 'badge-amber' },
  under_review: { label: 'In revisione',   cls: 'badge-amber' },
  certified:    { label: 'Certificato',    cls: 'badge-green' },
  rejected:     { label: 'Rifiutato',      cls: 'badge-red' },
};

const LEVEL_EMOJIS = { 1: '🥉', 2: '🥈', 3: '🥇' };

export default function AdminProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const LIMIT = 15;

  const load = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams({ page, limit: LIMIT });
    if (filter) params.append('status', filter);
    axios.get(`/api/projects/admin/all?${params}`)
      .then(r => { setProjects(r.data.rows || []); setTotal(r.data.count || 0); })
      .finally(() => setLoading(false));
  }, [filter, page]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <div className="topbar">
        <span className="topbar-title">Tutti i progetti</span>
        <span style={{ fontSize: 13, color: '#9B9A92' }}>{total} progetti totali</span>
      </div>
      <div className="page-content">
        {/* Filters */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
          {STATUSES.map(s => (
            <button key={s.value} onClick={() => { setFilter(s.value); setPage(1); }}
              className="btn btn-outline btn-sm"
              style={filter === s.value ? { background: '#EAF3DE', borderColor: '#97C459', color: '#3B6D11' } : {}}>
              {s.label}
            </button>
          ))}
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Progetto</th>
                <th>Azienda</th>
                <th>Data invio</th>
                <th>Punteggio</th>
                <th>Livello</th>
                <th>Stato</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 32, color: '#9B9A92' }}>Caricamento...</td></tr>
              ) : projects.length === 0 ? (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 32, color: '#9B9A92' }}>Nessun progetto trovato</td></tr>
              ) : projects.map(p => {
                const sm = STATUS_META[p.status];
                return (
                  <tr key={p.id}>
                    <td style={{ fontWeight: 500 }}>{p.name}</td>
                    <td style={{ color: '#5C5B55' }}>{p.company?.name || '—'}</td>
                    <td style={{ color: '#9B9A92' }}>{p.submittedAt ? new Date(p.submittedAt).toLocaleDateString('it-IT') : '—'}</td>
                    <td>
                      {p.scoreTotal > 0
                        ? `${p.scorePercentage != null ? Math.round(p.scorePercentage) : Math.round((p.scoreTotal / 125) * 100)}%`
                        : '—'}
                    </td>
                    <td>{p.certificationLevel ? LEVEL_EMOJIS[p.certificationLevel] + ' Liv. ' + p.certificationLevel : '—'}</td>
                    <td><span className={`badge ${sm.cls}`}>{sm.label}</span></td>
                    <td>
                      <Link to={`/admin/projects/${p.id}`} className="btn btn-ghost btn-sm" style={{ color: '#1D9E75' }}>
                        {['submitted', 'under_review'].includes(p.status) ? 'Esamina →' : 'Visualizza'}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {total > LIMIT && (
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 16 }}>
            <button className="btn btn-outline btn-sm" disabled={page === 1} onClick={() => setPage(p => p - 1)}>←</button>
            <span style={{ fontSize: 13, padding: '6px 12px', color: '#5C5B55' }}>Pagina {page} di {Math.ceil(total / LIMIT)}</span>
            <button className="btn btn-outline btn-sm" disabled={page >= Math.ceil(total / LIMIT)} onClick={() => setPage(p => p + 1)}>→</button>
          </div>
        )}
      </div>
    </>
  );
}
